import { useState } from "react";
import { useAllMessageCampaigns, useDeleteCampaign } from "../../../../App/Queries/CampaignQueries";
import { IDeleteCampaign } from "../../../../App/Typings/Campaigns";

export default function EmailCampaignListingState() {
  const pageSize = 5;
  const [page, setPage] = useState<number>(1);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState<boolean>(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState<string | undefined>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [isCreatingCampaign, setIsCreatingCampaign] = useState<boolean>(false);

  const { mutate: deleteCampaign, isLoading: isDeleting } = useDeleteCampaign();

  const {
    data: campaignData,
    isFetched: campaignDataFetched,
    isLoading: campaignDataLoading,
  } = useAllMessageCampaigns(page, pageSize, false);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleDeleteConfirmClick = () => {
    deleteCampaign(
      {
        campaignId: selectedCampaignId,
        shouldArchiveGroup: false,
      } as IDeleteCampaign,
      {
        onSuccess: () => {
          setIsConfirmDeleteOpen(false);
          setSelectedCampaignId(undefined);
          setPage(1);
        },
      },
    );
  };

  const handleDeleteCancelClick = () => {
    setIsConfirmDeleteOpen(false);
    setSelectedCampaignId(undefined);
  };

  const handleDeleteClick = (id: string) => {
    setSelectedCampaignId(id);
    setIsConfirmDeleteOpen(true);
  };

  const handleCreateCampaignClick = () => {
    setIsCreateModalOpen(true);
  };

  const handleCreateCampaignClose = () => {
    setIsCreateModalOpen(false);
  };

  const handleCampaignEditing = (isEditing: boolean) => {
    setIsCreatingCampaign(isEditing);
  };

  return {
    getters: {
      page,
      isConfirmDeleteOpen,
      isDeleting,
      isCreateModalOpen,
      campaignData,
      campaignDataLoaded: campaignDataFetched && !campaignDataLoading,
      isCreatingCampaign,
    },
    effects: {
      handlePageChange,
      handleDeleteConfirmClick,
      handleDeleteCancelClick,
      handleDeleteClick,
      handleCreateCampaignClick,
      handleCreateCampaignClose,
      handleCampaignEditing,
    },
  };
}
